// Module
var code = `<section class="{{\$ctrl.styles.unavailableWarning}}"> <img src="/assets/img/blip-sad.svg" alt="{{ 'attendance-unavailable.image.alt' | translate }}" title="{{ 'attendance-unavailable.image.title' | translate }}"/> <br> <h2 translate>attendance-unavailable.title</h2> <p translate>attendance-unavailable.description</p> </section> `;
// Exports
module.exports = code;